import BaseEntity from '@/entities/BaseEntity';

export default class RuleAdCreationDetails extends BaseEntity {
  conversion_location = null;
  conversion_event = null;
  optimization_goal = null;
  leadgen_form_id = null;

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
